module.exports = __webpack_public_path__ + "img/icon_sec3_5@2x.5d5c44ab.png";